import React from 'react'
import { Clock } from 'lucide-react'
import useLocaleText from 'components/useLocaleText'
import { ExecutionSkeleton } from './ExecutionSkeleton'
import { reviewLiterals } from './literals'
import styles from './styles.module.css'

export function EmptyReviewState({ media = true }: { media?: boolean }) {
  const t = useLocaleText(reviewLiterals)
  return (
    <div className={styles.emptyReview}>
      <div className={styles.emptyBackdrop} aria-hidden="true">
        <ExecutionSkeleton media={media} />
      </div>
      <div className={styles.emptyMessage} role="status">
        <Clock size={32} strokeWidth={1.5} />
        <strong>{t.noResultTitle}</strong>
        <p>{t.noResultHint}</p>
      </div>
    </div>
  )
}
